import React, {useMemo} from 'react';
import {useProviderProfile} from "../../../../ProviderProfileProvider";
import {TeamMemberInviteProto} from "../../../../provider_api";
import {KensuTable} from "../../../../components/table/KensuTable";
import {TabbedPageHeader} from "../../../../components/TabbedPageHeader";

import {useNavigateWithParams} from "../../../../util/NavUtils";
import {useTeamTabs} from "./TeamRouter";
import {shortDateTimeFormat2} from "../../../../util/DateTimeUtils";
import {findPractitioner} from "../Calendar/CalendarUtil";
import {getPractitionerName} from "../../../../util/ProviderUtil";
import {useBusinessLogins} from "../../../../util/RpcHooks/BusinessLoginsLoader";
import {useTeamMemberInvites} from "../../../../util/RpcHooks/useTeamMemberInvites";
import TeamMemberInviteStatus = TeamMemberInviteProto.TeamMemberInviteStatus;

export const TeamLogins = () => {

  const {businessProfile} = useProviderProfile();
  const navigate = useNavigateWithParams();
  
  const logins = useBusinessLogins({forAdminHeader: false});
  const invites = useTeamMemberInvites()

  const openInvites = useMemo(() => {
    return invites.invites.filter(invite => invite?.status === TeamMemberInviteStatus.AVAILABLE || invite.status === TeamMemberInviteStatus.OPENED)
  }, [invites.invites]);
  
  return <div className={'NonScrollingToolPage'}>

    <TabbedPageHeader pageTitle={'Team Members'}
                      tabs={useTeamTabs()}
                      buttons={[{text: 'Invite a User', link: 'invite'}]}/>

    <div className={'ProviderToolAreaContent'}>

      These are your team members who have access to your Kensu business account.
      <br/><br/>

      <KensuTable data={logins.logins} 
                  onRowSelected={r => navigate('edit/' + r.providerId)} columns={[
        {label: 'Login Email', render: p => p.lastLoginEmail, sortString: p => p.lastLoginEmail},
        {label: 'Roles', render: p => p.businessRoles?.join(', ') || ''},
        {label: 'Linked Practitioner', render: p => 
              getPractitionerName(findPractitioner(businessProfile?.practitioners, p.linkedPractitionerId))},
        {label: 'Last Login', render: p => shortDateTimeFormat2(p.lastLoginTimestamp), sortOrder: p => p.lastLoginTimestamp},
        {label: 'Contact email', render: p => p.contactEmail, sortString: p => p.contactEmail},
      ]}/>

      {logins.rpcState.state == 'pending' && 'Loading...'}
      {logins.rpcState.state == 'error' && <div className={'ErrorText'}>Error loading logins</div>}
      {logins.rpcState.state == 'success' && !logins.logins?.length && <div>
        <br/><br/>
        Click "Add" above to add invite a new login
      </div>}

      <br/><br/><br/>

      <h3>Pending Invitations</h3>

      {invites.rpcState.state == 'success' && !!openInvites.length && <KensuTable data={openInvites} columns={[
        {label: 'Invite timestamp', render: invite => shortDateTimeFormat2(invite.sentTimestamp), sortOrder: i => i.sentTimestamp},
        {label: 'Sent to email', render: invite => invite.sentToEmail, sortString: i => i.sentToEmail},
        {label: 'Status', render: invite => invite.status && TeamMemberInviteStatus[invite.status].toLowerCase()},
      ]}/>}

      {invites.rpcState.state == 'success' && !openInvites?.length && <div>
        No pending invitations found.
      </div>}

      {invites.rpcState.state == 'pending' && <div>Loading...</div>}
      {invites.rpcState.state == 'error' && <div className={'ErrorText'}>Error loading invites</div>}
   

    </div>
  </div>

};

